<div class="blog-action">
  <h1>{{ blogId ? "Edit" : "Add" }} Blog</h1>
  <div class="blog-action__content">
    <form [formGroup]="blogForm" (submit)="onSubmit()">
      <div class="">
        <div class="blog-action__row flex-wrap">
          <div class="blog-action__col">
            <div class="input-field">
              <label>Title <span>*</span></label>
              <input
                type="text"
                formControlName="title"
                placeholder="Enter Title"
                inNoWhitespace
              />
              <span
                *ngIf="blogForm.get('title')?.errors?.['required']&&(blogForm.get('title')?.dirty||blogForm.get('title')?.touched)"
              >
                Title is required
              </span>
            </div>
          </div>
          <div class="blog-action__col">
            <app-multiselect-dropdown
              [multiselect]="false"
              (lastElementIsVisible)="loadMoreIfLastIndex()"
              [optionLoading]="
                isLoading && ((categoryFilter | async)?.pageNumber ?? 0) === 1
              "
              [paginationLoading]="isLoading"
              [pagination]="categoryCount > categoryOptions.length"
              [config]="categoryDropdownSettings"
              [options]="categoryOptions"
              [control]="blogForm.get('category')"
              (searchEvent)="handleSearch($event)"
              [error]="(blogForm.get('category')?.errors?.['required']&&(blogForm.get('category')?.dirty||blogForm.get('category')?.touched))?'Category is required':''"
            >
            </app-multiselect-dropdown>
          </div>
          <div class="blog-action__col">
            <app-multiselect-dropdown
              (lastElementIsVisible)="loadMoreIfLastIndex()"
              [multiselect]="false"
              [searchable]="false"
              [config]="authorDropdownSettings"
              [options]="getAuthorOptions"
              [control]="blogForm.get('author')"
              (searchEvent)="handleSearch($event)"
              [error]="(blogForm.get('author')?.errors?.['required']&&(blogForm.get('author')?.dirty||blogForm.get('author')?.touched))?'Author is required':''"
            >
            </app-multiselect-dropdown>
          </div>
          <div class="blog-action__col">
            <div class="blog-action__date input-field">
              <label> Publish Date Time<span>*</span></label>
              <input type="datetime-local" formControlName="publishDateTime" />
              <!-- <span>Error message</span> -->
            </div>
          </div>
        </div>

        <div class="flex-wrap justify-between">
          <div class="blog-action__form">
            <div class="input-field">
              <label>Description <span>*</span></label>
              <textarea
                inNoWhitespace
                formControlName="description"
                placeholder="Enter Description"
              ></textarea>
              <span
                *ngIf="blogForm.get('description')?.errors?.['required']&&(blogForm.get('description')?.dirty||blogForm.get('description')?.touched)"
              >
                Description is required
              </span>
            </div>
          </div>

          <div class="blog-action__upload flex-col">
            <label>Upload Image <span>*</span></label>
            <div class="blog-action__file flex-col align-center justify-center">
              <app-upload-image
                (uploadEnd)="onImageUploadEnd($event)"
                (uploadStart)="onImageUploadStart()"
                [previewUrl]="imageUrl"
                (removeImage)="removeImage()"
              ></app-upload-image>
            </div>
            <div
              class="is-error"
              *ngIf="blogForm.get('img')?.errors?.['required']&&(blogForm.get('img')?.dirty||blogForm.get('img')?.touched)"
            >
              Image is required
            </div>
          </div>
        </div>
      </div>
      <div class="blog-action__editor">
        <app-custom-editor
          label="Blog Content"
          controlName="content"
          [form]="blogForm"
        ></app-custom-editor>
        <div
          class="blog-action__error"
          *ngIf="blogForm.get('content')?.errors?.['required']&&(blogForm.get('content')?.dirty||blogForm.get('content')?.touched)"
        >
          Content is required
        </div>
      </div>

      <div class="blog-action__tabs">
        <app-tab-group
          ><app-tab [tabTitle]="'Listen'">
            <app-upload-audio
              (uploadEnd)="onAudioUploadEnd($event)"
              (uploadStart)="onAudioUploadStart()"
              [previewUrl]="audioUrl"
              (removeAudio)="removeAudio()"
            ></app-upload-audio>
            <div
              class="blog-action__error"
              *ngIf="blogForm.get('audio')?.errors?.['required']&&(blogForm.get('audio')?.dirty||blogForm.get('audio')?.touched)"
            >
              Audio file is required
            </div>
          </app-tab>

          <app-tab [tabTitle]="'Summary'"
            ><app-blog-summary
              [summaryData]="blogForm.get('blogSummary')?.value || []"
              (addBlogSummary)="handleAddBlogSummary($event)"
              (updateBlogSummary)="updateBlogSummary($event)"
              (deleteSummary)="deleteSummary($event)"
            ></app-blog-summary></app-tab
          ><app-tab [tabTitle]="'Snapshot'">
            <div class="input-field">
              <label>Snapshot Content <span>*</span></label>
              <textarea
                formControlName="snapshot"
                placeholder="Enter snapshot text"
              ></textarea>
              <div
                class="blog-action__error"
                *ngIf="blogForm.get('snapshot')?.errors?.['required']&&(blogForm.get('snapshot')?.dirty||blogForm.get('snapshot')?.touched)"
              >
                Snapshot is required
              </div>
            </div>
          </app-tab>
          <app-tab [tabTitle]="'FAQ'">
            <app-blog-faq [blogForm]="blogForm"></app-blog-faq>
          </app-tab>
          <app-tab [tabTitle]="'Related Blogs'">
            <app-blog-links [blogId]="blogId" [form]="blogForm"></app-blog-links>
          </app-tab>
        </app-tab-group>
      </div>

      <div class="blog-action__footer flex justify-end">
        <app-button customClass="outline" (action)="cancel()" label="cancel">
        </app-button>
        <app-button
          [isDisabled]="isLoading || initialLoading || imageUploading"
          type="submit"
          label="Submit"
        >
          <app-button-loader
            *ngIf="isLoading"
            postfixContent
          ></app-button-loader>
        </app-button>
      </div>
    </form>
  </div>
</div>
